module.exports = __webpack_public_path__ + "img/logo-footer.b528a29a.png";